<template>
    <el-dialog title="发送消息" :visible.sync="data.visible" :close-on-click-modal="false" :append-to-body="false" :width="'60%'">
        <el-form ref="ruleForm" :model="formData" label-width="150px" :rules="rules">
            <el-form-item label="接收对象" prop="target" v-if="canChangeTarget">
                <el-radio-group v-model="formData.target">
                    <el-radio :label="99">向全部用户发送</el-radio>
                    <el-radio :label="1">向指定账号发送</el-radio>
                </el-radio-group>

                <div style="" v-if="formData.target == 1">
                    <el-button type="default" @click="chooseUser">请选择接收者</el-button>
                </div>
                <div v-if="formData.target == 1" v-text="formData.receiverName" style="font-size:16px; margin-top: 10px;color: #ff7600;"></div>
            </el-form-item>
            <el-form-item label="接收人" v-if="showReceiveTarget">
                <el-tag size="mini" class="mr10" v-for="(r, index) in receivers" :key="index">{{r.name}}</el-tag>
            </el-form-item>
            <el-form-item label="消息类型" prop="messageTypes">
                <el-checkbox-group v-model="formData.messageTypes">
                    <el-checkbox label="站内消息" :value="'InternalMessage'"></el-checkbox>
                    <el-checkbox label="手机短信" :value="'SMS'"></el-checkbox>
                    <el-checkbox label="邮件" :value="'Email'"></el-checkbox>
                    <el-checkbox label="微信模板消息" :value="'WeiXinTemplateMessage'"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="微信模板消息" v-if="hasSendTemplateMessage">
                <el-tag type="success" v-if="templateMessages && templateMessages.id && templateMessages.id.length > 0">{{templateMessages.title}}</el-tag>
                <el-tag type="danger" v-else>您尚未定义模板消息，无法通过微信模板消息发送通知，请先在微信公众平台与本系统的系统管理中预定义模板消息。</el-tag>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input placeholder="请输入标题" v-model="formData.title" />
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="formData.content" />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="data.visible = false">取消</el-button>
            <el-button type="primary" @click="handleSave()" v-loading="listLoading">确定</el-button>
        </div>
        <DlgChooseUser :data="dialogData" v-if="dialogData.dialogVisible" :api="api" :initQueryParams="this.data.initQueryParams"></DlgChooseUser>
    </el-dialog>
</template>
<script>
import WeiXinAPI from "@/web-framework/api/weixin.js";
import UserAPI from "@/web-framework/api/user.js";
export default {
    name: "DlgSendMessage",
    props: ["data"],
    components: {
        DlgChooseUser: () => import("./components/select_user.vue")
    },
    data() {
        return {
            listLoading: false,
            canChangeTarget: true, // 是否可更改接受者
            showReceiveTarget: false, // 是否显示接受者
            receivers: [], // 消息接受者数组
            queryParams: {},
            idPropertyName: '',
            isPrivate: false,
            formData: {
                target: 99,
                title: '',
                content: '',
                messageTypes: [],
            },
            templateMessages: {},
            dialogData: {
                dialogVisible: false,
                row: null,
                callback: this.afterSelectUser
            },
            rules: {
                target: [
                    { required: true, message: '请选择发送对象', trigger: 'blur' },
                ],
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                messageTypes: [
                    { required: true, message: '请选择发送方式', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入消息内容', trigger: 'blur' },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 200 个字符",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    computed: {
        hasSendTemplateMessage() {
            return this.formData.messageTypes && this.formData.messageTypes.length > 0 && this.formData.messageTypes.indexOf('微信模板消息') != -1;
        }
    },
    methods: {
        init(canChangeTarget, showReceiveTarget, receivers, isPrivate, api, queryParams, idPropertyName) {
            this.canChangeTarget = canChangeTarget;
            this.showReceiveTarget = showReceiveTarget;
            this.receivers = receivers;
            this.api = api;
            this.queryParams = queryParams;
            this.idPropertyName = idPropertyName;
            this.isPrivate = isPrivate;
            this.loadTemplateMessages();
        },
        // 获取微信模板消息
        loadTemplateMessages() {
            WeiXinAPI.findTemplateMessage().then(result => {
                this.templateMessages = result.data;
            });
        },
        chooseUser() {
            this.dialogData.visible = true;
        },
        handleSave() {
            this.listLoading = true;
            UserAPI.sendMessage(this.formData.messageTypes, this.api, this.queryParams, this.idPropertyName, this.receivers, this.formData.title, this.formData.content, this.isPrivate).then(result => {
                this.listLoading = false;
                Request.validateResult(result, () => {
                    this.$message.success("消息已成功发出");
                    this.data.visible = false;
                });
            }).catch(error => {
                this.listLoading = false;
                Request.validateCatchError(error);
            });
        },
    }
};
</script>